<section id="end_content" class="image_background" [style.background-image]="'url('+ imgBackground + ')'">
  <div class="end_content_container">
    <p class="mb-4 mx-auto mw-medium" i18n>Obtén tu <span style="font-style:italic;">protocolo personalizado</span> y
      sesión de
      coaching
    </p>
    <a *ngIf="!this.customEndpoint" class="button" i18n
      [href]="this.platformBaseUrl+'registro/?r='+this.referalCode+ (this.iparam ? '&i='+this.iparam:'')">Empieza
      ahora</a>
    <a id="customHrefButton" *ngIf="this.customEndpoint" class="button" i18n
      [href]="this.platformBaseUrl+this.customEndpoint">Comenzar ahora</a>
  </div>
</section>